import { makeStyles, tokens } from '@fluentui/react-components';

export const useBroadcastMessageReportPanelStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    table: {
        marginTop: tokens.spacingVerticalM,
        overflow: 'auto',
        flexGrow: 1,
        height: 'fit-content',
    },
    tableRow: {
        justifyContent: 'space-between',
        minHeight: '44px',
        minWidth: 'fit-content',
        padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalXL}`,
    },
    spinner: {
        position: 'absolute',
        minWidth: '100%',
        top: '50%',
    },
    messageGroup: {
        position: 'absolute',
        zIndex: 1000,
        top: '50px',
        right: 0,
        width: '350px',
    },
});
